import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_VISITA_KETO_NUTRICIONISTA = gql`
  mutation saveVisitaKetoNutricionista($input: AddVisitaKetoNutricionistaInput!) {
    saveVisitaKetoNutricionista(input: $input) {
      idVisita
      idVisitaKeto
    }
  }
`;

export default SAVE_VISITA_KETO_NUTRICIONISTA;

export const adaptAddVisitaKetoNutricionistaInput = (data) => ({
  idVisitaKeto: data?.idVisitaKeto,
  mismoRequerimiento: data?.mismoRequerimiento,
  calorica: data?.calorica,
  proteica: data?.proteica,
  fosforo: data?.fosforo,
  potasio: data?.potasio,
  sodio: data?.sodio,
  cantidad: data?.cantidad,
  idVisita: data?.idVisita
});